import React from "react";

const SavedIcon = ({ isActive }: { isActive: boolean }) => {
  return (
    <svg
      width="42"
      height="43"
      viewBox="0 0 42 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="21"
        cy="21.5"
        r="21"
        fill={isActive ? "#4E5257" : "#ebe8e8"}
      />
      <path
        d="M15.1663 23.9999C13.3247 23.9999 11.833 25.4916 11.833 27.3332C11.833 27.9582 12.008 28.5499 12.3163 29.0499C12.8913 30.0166 13.9497 30.6666 15.1663 30.6666C16.383 30.6666 17.4413 30.0166 18.0163 29.0499C18.3247 28.5499 18.4997 27.9582 18.4997 27.3332C18.4997 25.4916 17.008 23.9999 15.1663 23.9999ZM16.408 27.9416H15.7913V28.5916C15.7913 28.9332 15.508 29.2166 15.1663 29.2166C14.8247 29.2166 14.5413 28.9332 14.5413 28.5916V27.9416H13.9247C13.583 27.9416 13.2997 27.6582 13.2997 27.3166C13.2997 26.9749 13.583 26.6916 13.9247 26.6916H14.5413V26.0999C14.5413 25.7582 14.8247 25.4749 15.1663 25.4749C15.508 25.4749 15.7913 25.7582 15.7913 26.0999V26.6916H16.408C16.7497 26.6916 17.033 26.9749 17.033 27.3166C17.033 27.6582 16.758 27.9416 16.408 27.9416ZM28.9163 21.9166H26.833C25.9163 21.9166 25.1663 22.6666 25.1663 23.5832C25.1663 24.4999 25.9163 25.2499 26.833 25.2499H28.9163C29.1497 25.2499 29.333 25.0666 29.333 24.8332V22.3332C29.333 22.0999 29.1497 21.9166 28.9163 21.9166ZM24.774 16C25.024 16.2417 24.8157 16.6167 24.4657 16.6167L17.5657 16.6084C17.1657 16.6084 16.9657 16.125 17.249 15.8417L18.7074 14.375C19.9407 13.15 21.9323 13.15 23.1657 14.375L24.7407 15.9667C24.749 15.975 24.7657 15.9917 24.774 16Z"
        fill={isActive ? "#C8EE44" : "#363A3F"}
      />
      <path
        d="M29.2245 27.0499C28.7162 28.7666 27.2495 29.8333 25.2495 29.8333H19.8328C19.5078 29.8333 19.2995 29.4749 19.4328 29.1749C19.6828 28.5916 19.8412 27.9333 19.8412 27.3333C19.8412 24.8083 17.7828 22.7499 15.2578 22.7499C14.6245 22.7499 14.0078 22.8833 13.4411 23.1333C13.1328 23.2666 12.7578 23.0583 12.7578 22.7249V21.4999C12.7578 19.2333 14.1245 17.6499 16.2495 17.3833C16.4578 17.3499 16.6828 17.3333 16.9161 17.3333H25.2495C25.4662 17.3333 25.6745 17.3416 25.8745 17.3749C27.5578 17.5666 28.7745 18.5916 29.2245 20.1166C29.3078 20.3916 29.1078 20.6666 28.8245 20.6666H26.9162C25.1078 20.6666 23.6745 22.3166 24.0662 24.1916C24.3412 25.5583 25.6078 26.4999 26.9995 26.4999H28.8245C29.1162 26.4999 29.3078 26.7833 29.2245 27.0499Z"
        fill={isActive ? "#C8EE44" : "#363A3F"}
      />
    </svg>
  );
};

export default SavedIcon;
